import { Calendar } from "../models/calendar/Calendar.model";
import { clientFetch } from "./clientFetch";

export const CalendarService = {
  getCalendarByCompany: (uidCompany: string) =>
    clientFetch('/v2/calendar/calendar/get-bulk-calendars', 'POST', null, { body: { company: uidCompany } }),
  updateCalendar: (calendar: Partial<Calendar> & { users_enriched?: any[] }, company: any, key: string) => 
    clientFetch('/v2/calendar/calendar/update-calendar', 'POST', key, { 
      body: { 
        company: company.uid, 
        company_id: company.id,
        created_by_id: calendar.created_by_id,
        uidCalendar: calendar.uid, 
        calendar,
        users: calendar.users,
        users_enriched: calendar.users_enriched
      } 
    }),
  createCalendar: (calendar: Partial<Calendar>, company: any, key: string) => 
    clientFetch('/v2/calendar/calendar/create-calendar', 'POST', key, { 
      body: { 
        company: company.uid, 
        company_id: company.id,
        created_by_id: calendar.created_by_id,
        calendar,
        users: calendar.users || []
      } 
    }),
  getCalendarById: (uidCompany: string, uidCalendar: string) =>
    clientFetch('/v2/calendar/calendar/get-calendar', 'POST', null, { body: { company: uidCompany, uidCalendar } })
};